<div class="modal-header">
    <h4 class="modal-title">Payment Approver Update</h4>
</div>
<div class="modal-body">
    @if (successCount > 0) {
        <p>
            <span class="text-success">
                <i class="fa fa-check-circle"></i>
                {{ successCount }} payment{{ successCount !== 1 ? 's' : '' }} updated successfully.
            </span>
        </p>
    }
    @if (successCount === 0 && !hasFailures) {
        <p>No payments were updated.</p>
    }

    @if (hasFailures) {
        <p class="text-warning">
            <i class="fa fa-exclamation-triangle"></i>
            The following payments could not be updated:
        </p>
        <ul class="list-unstyled">
            @for (failure of failures; track failure.paymentId) {
                <li>
                    <strong>Payment ID {{ failure.paymentId }}:</strong> {{ failure.reason }}
                </li>
            }
        </ul>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
